"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOLTIP_DELAY_ON_AVATAR = exports.TOOLTIP_DELAY_ON_TIME_AGO = exports.NOTIFICATION_POLL_INTERVAL_TIME = exports.LOCALE = exports.DEFAULT_APP_LOCALE = exports.CROSS_CLOUD_CAPABILITIES = exports.TIME_FORMAT = exports.HIGH = exports.IMS_ORG_PARAM = exports.DATE_FORMAT = exports.FLOATING_NOTIFICATION_TIMEOUT_IN_MILLISECONDS = exports.TWENTY_FOUR_HOUR_IN_MILLISECONDS = exports.SIXTY_MINUTES_IN_MILLISECONDS = exports.FIFTEEN_MINUTES_IN_MILLISECONDS = exports.FIVE_MINUTES_IN_MILLISECONDS = exports.LONG_POLL_TIMEOUT_IN_SECONDS = exports.ADOBE_STATUS_ENDPOINT = exports.ADOBE_STATUS_STAGE_ENDPOINT = exports.ADOBE_STATUS_QA_ENDPOINT = exports.LONG_POLL_ENDPOINT = exports.LONG_POLL_STAGE_ENDPOINT = exports.SKMS_STAGE_ENDPOINT = exports.SKMS_ENDPOINT = exports.OR = exports.AND = exports.ANS_ENDPOINT = exports.ANS_STAGE_ENDPOINT = void 0;
var ANS_STAGE_ENDPOINT = 'https://notify-stage.adobe.io';
exports.ANS_STAGE_ENDPOINT = ANS_STAGE_ENDPOINT;
var ANS_ENDPOINT = 'https://notify.adobe.io';
exports.ANS_ENDPOINT = ANS_ENDPOINT;
var AND = 'AND';
exports.AND = AND;
var OR = 'OR';
exports.OR = OR;
var SKMS_ENDPOINT = 'https://data.status.adobe.com';
exports.SKMS_ENDPOINT = SKMS_ENDPOINT;
var SKMS_STAGE_ENDPOINT = 'https://data-status.stage.adobe.com';
exports.SKMS_STAGE_ENDPOINT = SKMS_STAGE_ENDPOINT;
var LONG_POLL_STAGE_ENDPOINT = 'https://stg-ans.oobesaas.adobe.com';
exports.LONG_POLL_STAGE_ENDPOINT = LONG_POLL_STAGE_ENDPOINT;
var LONG_POLL_ENDPOINT = 'https://ans.oobesaas.adobe.com';
exports.LONG_POLL_ENDPOINT = LONG_POLL_ENDPOINT;
var ADOBE_STATUS_QA_ENDPOINT = 'https://dev.status.adobe.com';
exports.ADOBE_STATUS_QA_ENDPOINT = ADOBE_STATUS_QA_ENDPOINT;
var ADOBE_STATUS_STAGE_ENDPOINT = 'https://status.stage.adobe.com';
exports.ADOBE_STATUS_STAGE_ENDPOINT = ADOBE_STATUS_STAGE_ENDPOINT;
var ADOBE_STATUS_ENDPOINT = 'http://status.adobe.com';
exports.ADOBE_STATUS_ENDPOINT = ADOBE_STATUS_ENDPOINT;
var LONG_POLL_TIMEOUT_IN_SECONDS = 540;
exports.LONG_POLL_TIMEOUT_IN_SECONDS = LONG_POLL_TIMEOUT_IN_SECONDS;
var FIVE_MINUTES_IN_MILLISECONDS = 5 * 60 * 1000;
exports.FIVE_MINUTES_IN_MILLISECONDS = FIVE_MINUTES_IN_MILLISECONDS;
var FIFTEEN_MINUTES_IN_MILLISECONDS = 15 * 60 * 1000;
exports.FIFTEEN_MINUTES_IN_MILLISECONDS = FIFTEEN_MINUTES_IN_MILLISECONDS;
var SIXTY_MINUTES_IN_MILLISECONDS = 60 * 60 * 1000;
exports.SIXTY_MINUTES_IN_MILLISECONDS = SIXTY_MINUTES_IN_MILLISECONDS;
var TWENTY_FOUR_HOUR_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
exports.TWENTY_FOUR_HOUR_IN_MILLISECONDS = TWENTY_FOUR_HOUR_IN_MILLISECONDS;
var FLOATING_NOTIFICATION_TIMEOUT_IN_MILLISECONDS = 5 * 1000;
exports.FLOATING_NOTIFICATION_TIMEOUT_IN_MILLISECONDS = FLOATING_NOTIFICATION_TIMEOUT_IN_MILLISECONDS;
var DATE_FORMAT = 'mmmm d, yyyy';
exports.DATE_FORMAT = DATE_FORMAT;
var IMS_ORG_PARAM = 'ims_org';
exports.IMS_ORG_PARAM = IMS_ORG_PARAM;
var HIGH = 'high';
exports.HIGH = HIGH;
var TIME_FORMAT = 'h:MMtt';
exports.TIME_FORMAT = TIME_FORMAT;
var CROSS_CLOUD_CAPABILITIES = "Cross-Cloud Capabilities";
exports.CROSS_CLOUD_CAPABILITIES = CROSS_CLOUD_CAPABILITIES;
var DEFAULT_APP_LOCALE = 'en-US'; //keeping it as a fallback;

exports.DEFAULT_APP_LOCALE = DEFAULT_APP_LOCALE;
var LOCALE = 'locale';
exports.LOCALE = LOCALE;
var NOTIFICATION_POLL_INTERVAL_TIME = 30000;
exports.NOTIFICATION_POLL_INTERVAL_TIME = NOTIFICATION_POLL_INTERVAL_TIME;
var TOOLTIP_DELAY_ON_TIME_AGO = 500;
exports.TOOLTIP_DELAY_ON_TIME_AGO = TOOLTIP_DELAY_ON_TIME_AGO;
var TOOLTIP_DELAY_ON_AVATAR = 2000;
exports.TOOLTIP_DELAY_ON_AVATAR = TOOLTIP_DELAY_ON_AVATAR;